import React, { useState,useEffect } from "react";
//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";

import {
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Spinner
} from "reactstrap";
import RamalStatus from "./RamalStatus";
import { getDashboardBranches, getDashboardStatus } from "../../helpers/backend_helper";

const DashboardSalidas = () => {
    document.title="Inicio Salidas | Sistema de Logística";

    const [loading, setLoading] = useState(false)
    const [branchLines, setBranchLines] = useState([])
    const [status, setStatus] = useState({
        salidas_activas: 0,
        salidas_time: 0,
        salidas_over: 0,
    })
    
    const getBranches = async () => {
        const response = await getDashboardBranches({})
        const branches = _.orderBy(response.branches, ['name'], ['asc']);
        setBranchLines(branches)
    }

    const getStatus = async () => {
        setLoading(true)
        try {
            const response = await getDashboardStatus({withToast: false})
            setStatus(response.status)
        } catch (error) {
            console.error(error)
        }
        setLoading(false)
    }

    useEffect(() => {
        getBranches()
        getStatus()
        const interval = setInterval(() => {
            getStatus()
        }, 1000 * 60 * 1)
        return () => clearInterval(interval);
    }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Estatus Salidas" />

                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    {loading && <div className="text-center">
                                        <Spinner color="primary" className="spinner-lg" />
                                    </div>}
                                    { (branchLines||[]).map((branch, index) => (
                                        <RamalStatus branch={branch} key={branch.id} salidas={status?.[branch.id] ?? []} />
                                    ))}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    
                </Container>
            </div>
        </React.Fragment>
    );
}
export default DashboardSalidas;